import { STORE_PROPS } from '../../constants';
import { usePaymentsStore } from '../../store';

const { ACTIVE_SERVICE_ID, ACTIVE_PAYMENT_TYPE, PAYMENT_SERVICES } =
  STORE_PROPS;

export const useGetCustomPaymentService = (customPaymentType = '') => {
  const { paymentServices } = usePaymentsStore([
    ACTIVE_SERVICE_ID,
    ACTIVE_PAYMENT_TYPE,
    PAYMENT_SERVICES
  ]);

  return paymentServices?.[customPaymentType] || {};
};
